import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import store from "./store/index";
import { logger, setLoggerReduxStore } from "./logging/logger";
import { OidcProvider } from "redux-oidc";
import userManager from "./auth/userManager";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { CssBaseline } from "@material-ui/core";
import CustomScrollbars from "./theme/CustomScrollbars";
import { httpClientInterceptors } from "./http-client/http-interceptors";
import "./i18n/i18n";
import { SnackbarProvider } from "notistack";
import Notifier from "./components/Notifier/Notifier";
import { faLibInit } from "./utils/faLib";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import CallbackComponent from './components/CallbackComponent';

setLoggerReduxStore(store);
faLibInit();

httpClientInterceptors.register();

const log = logger("index.js");

log.debug("Starting session");

// Global error handler
window.onerror = function(msg, url, lineNo, columnNo, error) {
  log.error({
    msg,
    url,
    lineNo,
    columnNo,
    error
  });
}


const app = (
  <ErrorBoundary>
    <Provider store={store}>
      <OidcProvider store={store} userManager={userManager}>
        <SnackbarProvider maxSnack={3}>
          <BrowserRouter basename="/">
            <>
              <CssBaseline />
              <CustomScrollbars />
              <Notifier />
              <Switch>
                <Route
                  path="/callback"
                  render={(props) => (
                    <CallbackComponent {...props}
                    userManager={userManager}
                    successCallback={(user) => {
                      window.history.replaceState({}, window.document.title, window.location.origin);
                      if (user.state) {
                        props.history.replace(user.state);
                      } else {
                        props.history.replace('/');
                      }
                    }}
                    />
                  )}
                />
                <Route><App /></Route>
              </Switch>
            </>
          </BrowserRouter>
        </SnackbarProvider>
      </OidcProvider>
    </Provider>
  </ErrorBoundary>
);

ReactDOM.render(app, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
